import { render, staticRenderFns } from "./mdc-ripple.vue?vue&type=template&id=7e5b79a0&scoped=true&"
import script from "./mdc-ripple.vue?vue&type=script&lang=ts&"
export * from "./mdc-ripple.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-ripple.vue?vue&type=style&index=0&id=7e5b79a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5b79a0",
  null
  
)

export default component.exports